module.exports = __webpack_public_path__ + "img/empty-business.770ee912.svg";